export enum AdminBannerListAction {
  Create,
}
